import { createSlice } from '@reduxjs/toolkit'
import { register } from '../../../helpers/reducerRegistry'

import {
  PERFORMANCE_SCORE_COLOR,
  SCORE_TYPE,
  TYPE_SELECT_SCORE,
} from '../constant'
import { getScoreRangesCreditRisk, getScoreRangesPerformance } from './thunk'

const initialState = {
  scoreActive: TYPE_SELECT_SCORE[0],
  loading: {
    score: true,
  },
  scoreRanges: {
    [SCORE_TYPE.CREDIT_RISK]: [],
    [SCORE_TYPE.PERFORMANCE]: [],
  },
}

const slice = createSlice({
  name: 'portfolio/score/overview',
  initialState,
  reducers: {
    changeScoreActive: (state, action) => {
      state.scoreActive = action.payload
    },
  },
  extraReducers: (builder) => {
    //getScoreRangesCreditRisk
    builder.addCase(
      getScoreRangesCreditRisk.fulfilled,
      (state, { payload = [] }) => {
        const newArr = [...payload]
        state.scoreRanges[SCORE_TYPE.CREDIT_RISK] = newArr.map(
          (item, index) => ({
            ...item,
            color: item.scoreRangeCode,
          }),
        )
        state.loading.score = !state.scoreRanges[SCORE_TYPE.PERFORMANCE].length
      },
    )
    //getScoreRangesPerformance
    builder.addCase(
      getScoreRangesPerformance.fulfilled,
      (state, { payload = [] }) => {
        const newArr = [...payload]
        state.scoreRanges[SCORE_TYPE.PERFORMANCE] = newArr.map(
          (item, index) => ({
            ...item,
            color: PERFORMANCE_SCORE_COLOR[index],
            scoreRange_Min: item.scoreRange_Min || undefined,
            scoreRange_Max: item.scoreRange_Max || undefined,
          }),
        )
        state.loading.score = !state.scoreRanges[SCORE_TYPE.PERFORMANCE].length
      },
    )
  },
})

export const selectScoreActive = (state) => state[slice.name].scoreActive
export const selectScoreRanges = (state) => state[slice.name].scoreRanges
export const getIsLoading = (type) => (state) => state[slice.name].loading[type]

export const { changeScoreActive } = slice.actions

register(slice.name, slice.reducer)
